import { connect, ConnectedProps } from 'react-redux';
import { reset } from 'redux-form';

import { FormContactUsV2Data } from 'dashboard/forms/FormContactUsV2/FormContactUsV2';
import SessionClientOnboard from 'dashboard/lib/clients/SessionClientOnboard';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { Organization } from 'dashboard/models/organization';
import { showMessage } from 'dashboard/redux/actions/messages';
import { RootState } from 'dashboard/redux/store';
import DashboardContactUsView from 'dashboard/views/DashboardContactUsView';
import { ApiModel } from 'lib/interfaces/api';

const DashboardContactUsRoute = ({ currentUser, organization, showMessage }: PropsFromRedux) => {
  const handleCreateTicket = async (formData: FormContactUsV2Data) => {
    // Structured data added to the beginning of the Zendesk ticket
    const descriptionPrefix = `
      Organization: ${organization ? `${organization.id} (${organization.attributes.name})` : '-'}
      User: ${
        currentUser
          ? `${currentUser.id} (${currentUser.attributes['name-first']} ${currentUser.attributes['name-last']})`
          : '-'
      }
      Form category: ${formData.helpCategoryName}
      -----
    `;

    try {
      await SessionClientOnboard.postResourceSingletonAction<Organization>(
        {
          type: ApiModel.Organization,
        },
        'create-ticket',
        {
          meta: {
            requesterName: formData.requesterName,
            requesterEmail: formData.requesterEmail,
            subject: '[Support Form] ' + formData.subject,
            description: descriptionPrefix + '\n\n' + formData.description,
            tags: formData.tags || [],
            organization_tier: organization?.attributes['customer-tier'],
          },
        },
      );

      showMessage('Your request has been submitted!', MessageType.Success);
    } catch {
      showMessage('Something went wrong, please try again.', MessageType.Failure);
    }
  };

  return <DashboardContactUsView currentUser={currentUser} createTicket={handleCreateTicket} />;
};

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: state.currentUser.currentUser,
    organization: state.organization.organization,
  };
};

const mapDispatchToProps = {
  showMessage,
  reset,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardContactUsRoute);
